import { CheckoutAnalyticsService } from '@analytics/feature';
import { Injectable } from '@angular/core';
import {
  CheckoutValidator,
  DELIVERY,
  SlotListArray,
  TimeSlot,
  TimeSlots,
  ValidationErrorKeys,
  ValidationErrors,
} from '@checkout/const';
import { ReceiptTypeFacade, TimeSlotsFacade } from '@checkout/data-access';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TimeSlotsService implements CheckoutValidator {
  constructor(
    private timeSlotsFacade: TimeSlotsFacade,
    private receiptTypeFacade: ReceiptTypeFacade,
    private checkoutAnalyticsService: CheckoutAnalyticsService,
  ) {}

  validate(): Observable<ValidationErrors> {
    return combineLatest([
      this.receiptTypeFacade.getActiveReceiptType(),
      this.getTimeSlots(),
      this.getCurrentTimeSlot(),
    ]).pipe(
      map(([receiptType, timeSlots, currentSlot]) => {
        const validationErrors: ValidationErrors = {};

        if (receiptType?.code === DELIVERY && timeSlots.length && !currentSlot) {
          validationErrors[ValidationErrorKeys.TIME_SLOT_REQUIRED] = 'Необходимо выбрать время доставки';
          this.checkoutAnalyticsService.alertNeedDeliveryDate();
        }

        return validationErrors;
      }),
    );
  }

  /**
   * При получении слотов произошла ошибка или получен пустой массив
   */
  isEmpty(): Observable<boolean> {
    return this.timeSlotsFacade.getTimeSlotsState().pipe(
      map((timeSlotsState) => {
        if (timeSlotsState.error) {
          return true;
        }

        if (timeSlotsState.success && !timeSlotsState.value?.slotListArray?.length) {
          return true;
        }

        return false;
      }),
    );
  }

  setTimeSlot(timeSlot?: TimeSlot): void {
    this.timeSlotsFacade.setTimeSlot(timeSlot);
  }

  resetTimeSlots(): void {
    this.timeSlotsFacade.resetTimeSlots();
  }

  getTimeSlots(): Observable<SlotListArray[]> {
    return this.timeSlotsFacade.getTimeSlots().pipe(
      // пришлось убрать фильтр на undefined, чтобы заработал коробочный ресет
      map((timeSlots: TimeSlots | undefined) => (timeSlots ? timeSlots.slotListArray : [])),
    );
  }

  getCurrentTimeSlot(): Observable<TimeSlot> {
    return this.timeSlotsFacade.getCurrentTimeSlot();
  }

  getLoading(): Observable<boolean> {
    return this.timeSlotsFacade.getLoading();
  }
}
